import { TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';

export const PrompSaveDirectiveModule = angular
  .module('acme.common.directive.promptSave', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.modals.save.controllers',
  ])
  .directive('promptSave', [
    function PrompSaveDirective() {
      return {
        restrict: 'A',
        replace: true,
        scope: {
          viewIds: '@',
          checkDirty: '&',
          save: '&',
          saveMessage: '@',
          dontSaveButtonText: '@',
          hideDontSave: '@',
          saveButtonText: '@',
          cancelButtonText: '@',
          headingText: '@',
        },

        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          '$uibModal',
          '$state',
          '$timeout',
          function PrompSaveController(
            $scope: IScope & {
              promptSave: TODO;
              cancelButtonText: TODO;
              checkDirty?: () => boolean;
              dontSaveButtonText: TODO;
              headingText: TODO;
              hideDontSave: TODO;
              save: TODO;
              saveButtonText: TODO;
              saveMessage: TODO;
              viewIds: TODO;
            },
            $uibModal: UIBModalService,
            $state: StateService,
            $timeout: ITimeoutService
          ) {
            $scope.promptSave = {
              nextState: false,

              modalDismissed: false,

              force: false,

              process: function (state, params) {
                let isDirty = false;

                if (state) {
                  this.nextState = state;
                  this.nextStateParams = params || {};
                }
                if ($scope.checkDirty && typeof $scope.checkDirty === 'function') {
                  isDirty = this.force || $scope.checkDirty();

                  if (isDirty) {
                    this.showModal();
                  } else {
                    this.continueToState();
                  }
                } else {
                  this.continueToState();
                }
              },

              showModal: function () {
                const self = $scope.promptSave;
                const modal = $uibModal.open<TODO>({
                  templateUrl: 'common/views/modals/save/save.tpl.html',
                  size: 'md',
                  controller: 'ModalsSaveController',
                  resolve: {
                    message: () => $scope.saveMessage || 'Would you like to save your changes?',
                    dontSaveButtonText: () => $scope.dontSaveButtonText || '',
                    saveButtonText: () => $scope.saveButtonText || '',
                    cancelButtonText: () => $scope.cancelButtonText || '',
                    headingText: () => $scope.headingText || '',
                    hideDontSave: () => $scope.hideDontSave !== undefined && $scope.hideDontSave === 'true',
                  },
                });

                // Invoked when modal completes with close(params)
                modal.result
                  .then((saveAndContinue) => {
                    if (saveAndContinue) {
                      self.save();
                    } else {
                      self.continueToState();
                    }
                  })
                  .catch(() => {
                    // noop
                  });
              },

              continueToState: function () {
                this.modalDismissed = true;
                this.force = false;

                if (this.nextState) {
                  $state.go(this.nextState, this.nextStateParams);
                }
              },

              save: function () {
                if ($scope.save && typeof $scope.save === 'function') {
                  $scope.save();
                }
              },

              /*
               * Is the stateName part of any current views
               */
              includesView: function (stateName) {
                let r = false;
                const list = $scope.viewIds ? JSON.parse($scope.viewIds) : [];

                for (let i = 0, ii = list.length; i < ii; i++) {
                  const re = new RegExp('^' + list[i] + '.*');
                  if (re.test(stateName)) {
                    r = list[i];
                    break;
                  }
                }

                return r;
              },
            };

            $scope.$on('pageContent::startLoad', function (event, data) {
              const self = $scope.promptSave;

              if (!self.modalDismissed && data && data.from) {
                const found = self.includesView(data.from.name);
                if (found && !self.includesView(data.to.name)) {
                  //if we are not still inside the view, then check if the data is dirty and show a modal to save.
                  if (typeof data.event.abort === 'function') {
                    data.event.abort();
                  }

                  $timeout(function () {
                    self.process(data.to, data.toParams);
                  }, 0);
                }
              }
            });

            $scope.$on('promptSave::Complete', function (event, data) {
              $scope.promptSave.continueToState();
            });

            $scope.$on('promptSave::Error', function (event, data) {
              //do nothing. The user will see the error on the page.
              $scope.promptSave.force = true;
            });
          },
        ],
      };
    },
  ]).name;
